<template>
  <div
    class="row m-0"
    :class="showTooltip ? 'coozzyDropdownItemTooltip' : ''">
    <coozzy-dropdown-item
      class="col pr-0 pl-0"
      :disabled="isDisabled"
      @click="handleClick">
      {{ $t('message.ticketOverview.reportDamageInsurance') }}
    </coozzy-dropdown-item>
    <div
      v-if="showTooltip"
      class="pl-0">
      <coozzy-info-circle-icon
        v-b-tooltip.hover="$t('message.aicSynchronization.reportDamageDisabledTooltip')"
        class="mt-2" />
    </div>
  </div>
</template>

<script lang="ts">
import CoozzyDropdownItem from '@/framework/components/dropdown/CoozzyDropdownItem.vue'
import CoozzyInfoCircleIcon from '@/framework/components/icons/CoozzyInfoCircleIcon.vue'
import { aic } from '@/mixins/aic'

export default {
  name: 'ReportDamageDropdownItem',
  components: {
    CoozzyDropdownItem,
    CoozzyInfoCircleIcon
  },
  mixins: [aic],
  props: {
    properties: {
      type: Array,
      default: () => []
    },
    additionalDisabled: {
      type: Boolean,
      default: false
    },
    clickHandler: {
      type: Function,
      default: null
    }
  },
  computed: {
    isDisabled() {
      return this.hasAicReportDamageDisabledProperties(this.properties) || this.hasAicPendingProperties(this.properties) || this.hasWithoutSupport() || this.additionalDisabled
    },
    showTooltip() {
      return this.isDisabled && this.hasWithoutSupport() && !this.hasAicReportDamageDisabledProperties(this.properties)
    }
  },
  methods: {
    handleClick() {
      if (!this.isDisabled && this.clickHandler) {
        this.clickHandler()
      }
    },
    hasWithoutSupport(): boolean {
      return this.hasAicWithoutSupportProperties(this.properties)
    }
  }
}
</script>
